import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isProviderSeatRole } from '@constants/Providers'
import type { Provider } from '@dataTypes/provider.types'
import { fetchAllProviders } from '@store/actions/providermanagement.action'
import type { AppDispatch, RootState } from '@store/index'

export const useProvidersForBilling = (): Provider[] => {
  const dispatch = useDispatch<AppDispatch>()
  const providers = useSelector((state: RootState) => state.provider.data)
  const clinicId = useSelector(
    (state: RootState) => state.clinic.selectedClinic?.clinic_id,
  )

  useEffect(() => {
    void dispatch(fetchAllProviders())
  }, [dispatch, clinicId])

  return useMemo(
    () => providers.filter((p) => isProviderSeatRole(p.work_role)),
    [providers],
  )
}
